import React, { Component } from 'react'

export default class FileDragAndDrop extends Component {
  state = {
    drag: false
  }
  dropRef = React.createRef()
  handleDrag = (e) => {
    e.preventDefault();
    if (this.props.disabled) return;
    e.stopPropagation();
  }
  handleDragIn = (e) => {
    e.preventDefault();
    if (this.props.disabled) return;
    e.stopPropagation();
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
    }
  }
  handleDragOut = (e) => {
    e.preventDefault();
    if (this.props.disabled) return;
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter > 0) return;
    this.setState({ drag: false });
  }
  handleDrop = (e) => {
    e.preventDefault();
    if (this.props.disabled) return;
    e.stopPropagation();
    this.setState({ drag: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e.dataTransfer.files);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
  }
  componentDidMount() {
    this.dragCounter = 0;
    let div = this.dropRef.current;
    div.addEventListener('dragenter', this.handleDragIn);
    div.addEventListener('dragleave', this.handleDragOut);
    div.addEventListener('dragover', this.handleDrag);
    div.addEventListener('drop', this.handleDrop);
  }
  componentWillUnmount() {
    let div = this.dropRef.current;
    div.removeEventListener('dragenter', this.handleDragIn);
    div.removeEventListener('dragleave', this.handleDragOut);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }
  render() {
    return (
      <div
        style={{ display: 'inline-block', position: 'relative', ...this.props.style }}
        ref={this.dropRef}
      >
        {!this.props.disabled && this.state.drag ?
          <div
            style={{
              border: 'dashed grey 2px',
              backgroundColor: 'rgba(255,255,255,.8)',
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 9999
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                right: 0,
                left: 0,
                textAlign: 'center',
                color: 'grey',
                fontSize: 12
              }}
            >
              <div>drop here!</div>
            </div>
          </div>
          : <React.Fragment />
        }
        {this.props.children}
      </div>
    )
  }
}